module.exports = __webpack_public_path__ + "static/media/05.0910554c.jpg";